import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import _uniq from 'lodash-es/uniq'

import * as state from '../../../../../../../state'
import { Store } from '../store'

/**
 * Displays a {@link ents.core.summit.CheckIn.Response}
 */
@ngCore.Component({
  selector: 'atn-summit-check-ins-entry',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /** @see {@link ents.core.summit.CheckIn.Response} */
  public readonly entrySg =
    ngCore.input.required<ents.core.summit.CheckIn.Response>({ alias: 'entry' })

  /**
   * The formatted date for this {@link ents.core.summit.CheckIn.Response}
   */
  public readonly respondentSg = ngCore.computed(
    (
      entry = this.entrySg(),
      currentUserId = this.meFeature.selectors.currentUserId.asSignal(),
    ) => (entry.from.id === currentUserId ? 'You' : entry.from.name),
  )

  /**
   * The formatted date for this {@link ents.core.summit.CheckIn.Response}
   */
  public readonly formattedDateSg = ngCore.computed((entry = this.entrySg()) =>
    this.store.extractFormattedDate(entry),
  )
}
